import type { GridUserSettings } from '@awork/framework/state/settings.types'

export enum CompanyColumn {
  Name = 'name',
  Tags = 'tags',
  Projects = 'projects',
  Industry = 'industry',
  Location = 'location'
}

export const defaultCompanyPageSettings: GridUserSettings<CompanyColumn> = {
  sortBy: { value: CompanyColumn.Name, orderBy: 'asc' },
  gridColumnSettings: [
    {
      id: CompanyColumn.Name,
      width: 300,
      visible: true
    },
    {
      id: CompanyColumn.Tags,
      width: 160,
      visible: true
    },
    {
      id: CompanyColumn.Projects,
      width: 140,
      visible: true
    },
    {
      id: CompanyColumn.Industry,
      width: 160,
      visible: true
    },
    {
      id: CompanyColumn.Location,
      width: 220,
      visible: true
    }
  ]
}
